import { useEffect } from 'react';
import moment from 'moment/moment';
import { getDays, getMonths, getWeeks } from '../../helpers/getDays';
import { stageSelector } from '../../store/reducers/stageSlice/stageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../store/reducers/gantSlice/gantSlice';
import { charterSelector } from '../../store/reducers/charterSlice/charterSlice';

export const useGant = () => {
    const chartersEntities = useSelector(charterSelector.selectEntities);

    const stages = useSelector(stageSelector.selectAll);
    const { settings, isNeedUpdateStart, firstStageStart } = useSelector(
        (state) => state.gantReducer
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (stages.length) {
            const firstStageStart = [...stages]
                .filter((stage) => stage.planned.start_date)
                .sort(
                    (stageA, stageB) =>
                        moment(stageA.planned.start_date).valueOf() -
                        moment(stageB.planned.start_date).valueOf()
                )[0]?.planned.start_date;

            const lastStageEnd = [...stages]
                .filter((stage) => stage.planned.end_date)
                .sort(
                    (stageA, stageB) =>
                        moment(stageA.planned.end_date).valueOf() -
                        moment(stageB.planned.end_date).valueOf()
                )
                .slice(-1)[0]?.planned.start_date;

            let start = firstStageStart
                ? moment(firstStageStart).format('MM.YYYY')
                : moment().format('MM.YYYY');
            let end = moment().format('MM.YYYY');
            if (lastStageEnd && moment(end).isAfter(moment(lastStageEnd))) {
                end = moment(lastStageEnd).format('MM.YYYY');
            }

            if (isNeedUpdateStart) {
                const nowDate = moment().format('MM.YYYY');
                if (!moment(start, 'MM.YYYY').isBefore(moment(nowDate, 'MM.YYYY'))) {
                    start = nowDate;
                }

                dispatch(gantActions.changeNeedUpdateStart(false));
                const daysData = getDays(start);
                const monthsData = getMonths(start);
                const weeksData = getWeeks(start);

                dispatch(gantActions.setDays(daysData));
                dispatch(gantActions.setWeeks(weeksData));
                dispatch(gantActions.setMonths(monthsData));
            }
        }
    }, [stages]);

    useEffect(() => {
        const isDemo = $(document).find(`[data-demo]`).attr(`data-demo`);

        if (isDemo === 'true') {
            dispatch(gantActions.changeSettings({ ...settings, isShowMHD: true }));
            const initIsOpenStage = {};
            const initIsOpenCharter = {};
            stages.forEach((stage) => {
                initIsOpenStage[stage.id] = true;
                stage.positions.forEach((charterGuid) => {
                    if (!!chartersEntities[charterGuid]) {
                        initIsOpenCharter[charterGuid] = true;
                    }
                });
            });

            dispatch(gantActions.changeOpenStage(initIsOpenStage));
            dispatch(gantActions.changeOpenCharters(initIsOpenCharter));
        }
    }, [stages]);
};
